import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { FhcStoreProvider } from './store/FhcStoreContext';
import { AuthProvider } from './hooks/useAuth';
import PrivateRoute from './components/layout/PrivateRoute';

// Import du système de responsivité
import './styles/responsive.css';

import AuthPage from './pages/AuthPage';
import FinalHubPage from './pages/FinalHubPage';
import DashboardDGPage from './pages/DashboardDGPage';
import DashboardComptabilitePage from './pages/DashboardComptabilitePage';
import DashboardLocationPage from './pages/DashboardLocationPage';
import DashboardRHPage from './pages/DashboardRHPage';
import DashboardMarketingPage from './pages/DashboardMarketingPage';
// import DashboardMarketingPageNew from './pages/DashboardMarketingPageNew'; // Désactivé temporairement - nécessite Material-UI
import DashboardProjetsPage from './pages/DashboardProjetsPage';
import DashboardTechnologiePage from './pages/DashboardTechnologiePage';
import DashboardCaissePage from './pages/DashboardCaissePage';
import BaseDonneesPage from './pages/BaseDonneesPage';
import ComptabilitePage from './pages/ComptabilitePage';
import CrmPage from './pages/CrmPage';
import EmploiPlusPage from './pages/EmploiPlusPage';
import ProjetsPage from './pages/ProjetsPage';
import RhPage from './pages/RhPage';
import PaiePage from './pages/PaiePage';
import PlateformePage from './pages/PlateformePage';
import RapportsPage from './pages/RapportsPage';
import TdbEmployesPage from './pages/TdbEmployesPage';
import TdbIndividuelPage from './pages/TdbIndividuelPage';
import TdbEmployePage from './pages/TdbEmployePage';
import AfricaLocationPage from './pages/AfricaLocationPage';
import AgendaPage from './pages/AgendaPage';
import EmployesPage from './pages/EmployesPage';
import EtatsFinanciersPage from './pages/EtatsFinanciersPage';
import StoreIntegrationPage from './pages/StoreIntegrationPage';
import DocumentsPage from './pages/DocumentsPage';

// Exemple de dashboard responsive (pour développement)
// import DashboardResponsiveExample from './pages/DashboardResponsiveExample';

const P = ({ children }) => <PrivateRoute>{children}</PrivateRoute>;

function App() {
  return (
    <AuthProvider>
      <FhcStoreProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/hub" element={<P><FinalHubPage /></P>} />
            <Route path="/dashboard-dg" element={<P><DashboardDGPage /></P>} />
            <Route path="/dashboard-comptabilite" element={<P><DashboardComptabilitePage /></P>} />
            <Route path="/dashboard-location" element={<P><DashboardLocationPage /></P>} />
            <Route path="/dashboard-rh" element={<P><DashboardRHPage /></P>} />
            <Route path="/dashboard-marketing" element={<P><DashboardMarketingPage /></P>} />
            <Route path="/dashboard-projets" element={<P><DashboardProjetsPage /></P>} />
            <Route path="/dashboard-technologie" element={<P><DashboardTechnologiePage /></P>} />
            <Route path="/dashboard-caisse" element={<P><DashboardCaissePage /></P>} />
            <Route path="/base-donnees" element={<P><BaseDonneesPage /></P>} />
            <Route path="/comptabilite" element={<P><ComptabilitePage /></P>} />
            <Route path="/crm" element={<P><CrmPage /></P>} />
            <Route path="/emploi-plus" element={<P><EmploiPlusPage /></P>} />
            <Route path="/projets" element={<P><ProjetsPage /></P>} />
            <Route path="/rh" element={<P><RhPage /></P>} />
            <Route path="/paie" element={<P><PaiePage /></P>} />
            <Route path="/plateforme" element={<P><PlateformePage /></P>} />
            <Route path="/rapports" element={<P><RapportsPage /></P>} />
            <Route path="/tdb-employes" element={<P><TdbEmployesPage /></P>} />
            <Route path="/tdb-employe" element={<P><TdbEmployePage /></P>} />
            <Route path="/tdb-individuel" element={<P><TdbIndividuelPage /></P>} />
            <Route path="/africa-location" element={<P><AfricaLocationPage /></P>} />
            <Route path="/agenda" element={<P><AgendaPage /></P>} />
            <Route path="/employes" element={<P><EmployesPage /></P>} />
            <Route path="/etats-financiers" element={<P><EtatsFinanciersPage /></P>} />
            <Route path="/store-integration" element={<P><StoreIntegrationPage /></P>} />
            <Route path="/documents" element={<P><DocumentsPage /></P>} />
            
            <Route path="/" element={<Navigate to="/auth" replace />} />
            <Route path="*" element={<Navigate to="/auth" replace />} />

          </Routes>
        </BrowserRouter>
      </FhcStoreProvider>
    </AuthProvider>
  );
}

export default App;
